import React from 'react'
import TableCell from '@material-ui/core/TableCell'
function summeWithStorno(
    text: any,
    id: any,
    index: number,
    data: any,
    VisitData: any,
    VisitDataDel: boolean,
    Store: any,
    tableBodyPositionElement: any
) {
    //console.log(data);
    let PriceHolder = 0;
    for(let summ=0; summ<text.length; summ++){

        let TMPPrice = text[summ].quantity * text[summ].unit_price;
        PriceHolder = PriceHolder + TMPPrice;
    }
    let currency = (data.payment !== null && data.payment !== undefined ? data.payment.currency_code : 'EUR')
    let summe = (PriceHolder + data.fixShippingCost) / 100
    let ConvertSum = Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
    }).format(summe)
    return (
        <>
            <TableCell
                style={{ textAlign: tableBodyPositionElement }}
                key={'td' + id + '_' + index}
                data-param={VisitData}
                data-param-del={VisitDataDel}
                data-id={id}
                id={'td' + id + '_' + index}
            >
                {ConvertSum}
            </TableCell>
        </>
    )
}

export default summeWithStorno
